// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu h1 {
    text-decoration: underlined;
  }
  .components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu .components-MissingTransactionsTool-styles___inputRow--t1F5K {
    display: flex;
    align-items: center;
  }
  .components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu .components-MissingTransactionsTool-styles___inputRow--t1F5K > * {
      margin-right: 16px;
      margin-top: 8px;
      margin-bottom: 8px;
    }
  .components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu .components-MissingTransactionsTool-styles___inputRow--t1F5K .components-MissingTransactionsTool-styles___inputDivider--c6zwm {
      margin-right: 32px;
      margin-left: 16px;
    }
  .components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu .components-MissingTransactionsTool-styles___button--pTe5w {
    margin-right: 16px;
  }
  .components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu .components-MissingTransactionsTool-styles___lineBreak--uDprf {
    border-top: 1px solid rgb(164, 167, 173);
  }
  .components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu .components-MissingTransactionsTool-styles___message-List--M4b2T {
    border: 1px solid black;
    padding: 0;
  }
  .components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu .components-MissingTransactionsTool-styles___message-List--M4b2T .components-MissingTransactionsTool-styles___message--aCjYF {
      border: 1px solid black;
      padding: 6px 8px;
      list-style: none;
    }
`, "",{"version":3,"sources":["webpack://./components/MissingTransactionsTool/styles.pcss"],"names":[],"mappings":"AACE;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,mBAAmB;EAUrB;EATE;MACE,kBAAkB;MAClB,eAAe;MACf,kBAAkB;IACpB;EACA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;EAEF;IACE,kBAAkB;EACpB;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,uBAAuB;IACvB,UAAU;EAOZ;EALE;MACE,uBAAuB;MACvB,gBAAgB;MAChB,gBAAgB;IAClB","sourcesContent":[".MissingTransactionTool {\n  h1 {\n    text-decoration: underlined;\n  }\n  .inputRow {\n    display: flex;\n    align-items: center;\n    > * {\n      margin-right: 16px;\n      margin-top: 8px;\n      margin-bottom: 8px;\n    }\n    .inputDivider {\n      margin-right: 32px;\n      margin-left: 16px;\n    }\n  }\n  .button {\n    margin-right: 16px;\n  }\n  .lineBreak {\n    border-top: 1px solid rgb(164, 167, 173);\n  }\n  .message-List {\n    border: 1px solid black;\n    padding: 0;\n\n    .message {\n      border: 1px solid black;\n      padding: 6px 8px;\n      list-style: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"missingTransactionTool": `components-MissingTransactionsTool-styles___MissingTransactionTool--pjVSu`,
	"inputRow": `components-MissingTransactionsTool-styles___inputRow--t1F5K`,
	"inputDivider": `components-MissingTransactionsTool-styles___inputDivider--c6zwm`,
	"button": `components-MissingTransactionsTool-styles___button--pTe5w`,
	"lineBreak": `components-MissingTransactionsTool-styles___lineBreak--uDprf`,
	"messageList": `components-MissingTransactionsTool-styles___message-List--M4b2T`,
	"message": `components-MissingTransactionsTool-styles___message--aCjYF`
};
module.exports = ___CSS_LOADER_EXPORT___;
